export default "__VITE_ASSET__madOqsYI__"